import type { MessageInstance } from "antd/es/message/interface";
import type { NotificationInstance } from "antd/es/notification/interface";
import { notification as staticNotification } from "antd";

/**
 * Holds Ant Design App-scoped notification API so axios interceptors
 * (outside React) can show toasts that render under ConfigProvider / React 19.
 */
let notificationApi: NotificationInstance | null = null;

export function registerToastApis(
  _message: MessageInstance,
  notification: NotificationInstance
) {
  notificationApi = notification;
}

const api = () => notificationApi || staticNotification;

/** All toasts use notification so they reliably appear top-right. */
export const toast = {
  success(content: string) {
    api().success({ message: content, placement: "topRight" });
  },
  error(content: string) {
    api().error({ message: content, placement: "topRight" });
  },
  warning(content: string) {
    api().warning({ message: content, placement: "topRight" });
  },
  info(content: string) {
    api().info({ message: content, placement: "topRight" });
  },
  notifySuccess(content: string, description?: string) {
    api().success({
      message: content,
      description,
      placement: "topRight",
    });
  },
  notifyError(content: string, description?: string) {
    api().error({
      message: content,
      description,
      placement: "topRight",
    });
  },
};
